export default {
    dataSegmentList: {},
    dataSegmentFields: [
        {
            key: 'title',
            label: 'Data Segment Title',
            sortable: true,
        },
        {
            key: 'code',
            label: 'Short Code',
            class: 'text-center',
            sortable: true,
        },
        {
            key: 'email',
            label: 'Email',
            class: 'text-center',
            sortable: true,
        },
        {
            key: 'dataSegmentType',
            label: 'Type',
            class: 'text-center',
            sortable: true,
        },
        {
            key: 'status',
            label: 'Status',
            sortable: true,
            class: 'text-center status-absolute-pos',
        },
        {
            key: 'action',
            label: 'Action',
            tdClass: 'user-roles-action',
        },
    ],
    dataSegmentId: null,
    dataSegmentType: null,
    nationalities: [
        { value: null, text: 'Select Country', disabled: true },
        'Afghanistan',

        'Aland Islands',

        'Albania',

        'Algeria',

        'American Samoa',

        'Andorra',

        'Angola',

        'Anguilla',

        'Antarctica',

        'Antigua and Barbuda',

        'Argentina',

        'Armenia',

        'Aruba',

        'Australia',

        'Austria',

        'Azerbaijan',

        'Bahamas',

        'Bahrain',

        'Bangladesh',

        'Barbados',

        'Belarus',

        'Belgium',

        'Belize',

        'Benin',

        'Bermuda',

        'Bhutan',

        'Bolivia',

        'Bonaire, Sint Eustatius and Saba',

        'Bosnia and Herzegovina',

        'Botswana',

        'Bouvet Island',

        'Brazil',

        'British Indian Ocean Territory',

        'Brunei Darussalam',

        'Bulgaria',

        'Burkina Faso',

        'Burundi',

        'Cabo Verde',

        'Cambodia',

        'Cameroon',

        'Canada',

        'Cayman Islands',

        'Central African Republic',

        'Chad',

        'Chile',

        'China',

        'Christmas Island',

        'Cocos (Keeling) Islands',

        'Colombia',

        'Comoros',

        'Congo',

        'Cook Islands',

        'Costa Rica',

        "Cote d'Ivoire",

        'Croatia',

        'Cuba',

        'Curacao',

        'Cyprus',

        'Czechia',

        'Democratic Republic of the Congo',

        'Denmark',

        'Djibouti',

        'Dominica',

        'Dominican Republic',

        'Ecuador',

        'Egypt',

        'El Salvador',

        'Equatorial Guinea',

        'Eritrea',

        'Estonia',

        'Ethiopia',

        'Falkland Islands',

        'Faroe Islands',

        'Fiji',

        'Finland',

        'France',

        'French Guiana',

        'French Polynesia',

        'French Southern Territories',

        'Gabon',

        'Gambia',

        'Georgia',

        'Germany',

        'Ghana',

        'Gibraltar',

        'Greece',

        'Greenland',

        'Grenada',

        'Guadeloupe',

        'Guam',

        'Guatemala',

        'Guernsey',

        'Guinea',

        'Guinea-Bissau',

        'Guyana',

        'Haiti',

        'Heard Island and McDonald Islands',

        'Holy See',

        'Honduras',

        'Hong Kong',

        'Hungary',

        'Iceland',

        'India',

        'Indonesia',

        'Iran',

        'Iraq',

        'Ireland',

        'Isle of Man',

        'Israel',

        'Italy',

        'Jamaica',

        'Japan',

        'Jersey',

        'Jordan',

        'Kazakhstan',

        'Kenya',

        'Kiribati',

        "Korea (Democratic People's Republic of)",

        'Korea (Republic of)',

        'Kuwait',

        'Kyrgyzstan',

        "Lao People's Democratic Republic",

        'Latvia',

        'Lebanon',

        'Lesotho',

        'Liberia',

        'Libya',

        'Liechtenstein',

        'Lithuania',

        'Luxembourg',

        'Macao',

        'Macedonia (the former Yugoslav Republic of)',

        'Madagascar',

        'Malawi',

        'Malaysia',

        'Maldives',

        'Mali',

        'Malta',

        'Marshall Islands',

        'Martinique',

        'Mauritania',

        'Mauritius',

        'Mayotte',

        'Mexico',

        'Micronesia',

        'Moldova',

        'Monaco',

        'Mongolia',

        'Montenegro',

        'Montserrat',

        'Morocco',

        'Mozambique',

        'Myanmar',

        'Namibia',

        'Nauru',

        'Nepal',

        'Netherlands',

        'New Caledonia',

        'New Zealand',

        'Nicaragua',

        'Niger',

        'Nigeria',

        'Niue',

        'Norfolk Island',

        'Northern Mariana Islands',

        'Norway',

        'Oman',

        'Pakistan',

        'Palau',

        'Palestine, State of',

        'Panama',

        'Papua New Guinea',

        'Paraguay',

        'Peru',

        'Philippines',

        'Pitcairn',

        'Poland',

        'Portugal',

        'Puerto Rico',

        'Qatar',

        'Reunion',

        'Romania',

        'Russian Federation',

        'Rwanda',

        'Saint Barthelemy',

        'Saint Helena, Ascension and Tristan da Cunha',

        'Saint Kitts and Nevis',

        'Saint Lucia',

        'Saint Martin (French part)',

        'Saint Pierre and Miquelon',

        'Saint Vincent and the Grenadines',

        'Samoa',

        'San Marino',

        'Sao Tome and Principe',

        'Saudi Arabia',

        'Senegal',

        'Serbia',

        'Seychelles',

        'Sierra Leone',

        'Singapore',

        'Sint Maarten (Dutch part)',

        'Slovakia',

        'Slovenia',

        'Solomon Islands',

        'Somalia',

        'South Africa',

        'South Georgia and the South Sandwich Islands',

        'South Sudan',

        'Spain',

        'Sri Lanka',

        'Sudan',

        'Suriname',

        'Svalbard and Jan Mayen',

        'Swaziland',

        'Sweden',

        'Switzerland',

        'Syrian Arab Republic',

        'Taiwan',

        'Tajikistan',

        'Tanzania, United Republic of',

        'Thailand',

        'Timor-Leste',

        'Togo',

        'Tokelau',

        'Tonga',

        'Trinidad and Tobago',

        'Tunisia',

        'Turkey',

        'Turkmenistan',

        'Turks and Caicos Islands',

        'Tuvalu',

        'Uganda',

        'Ukraine',

        'United Arab Emirates',

        'United Kingdom',

        'United States Minor Outlying Islands',

        'United States of America',

        'Uruguay',

        'Uzbekistan',

        'Vanuatu',

        'Venezuela',

        'Viet Nam',

        'Virgin Islands (British)',

        'Virgin Islands (U.S.)',

        'Wallis and Futuna',

        'Western Sahara',

        'Yemen',

        'Zambia',

        'Zimbabwe',
    ],
}
